import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { getMagazines, getUploadUrl } from '../services/api';
import Newsletter from '../components/Newsletter';
import { MAGAZINES } from "../data/magazines";
import useFadeIn from '../hooks/useFadeIn';
import '../css/magazine.css';
import '../css/sections.css';

/* Only ever show women — this page hard-filters on gender, regardless of
   what the API/fallback data returns. */
const FALLBACK_MAGS = MAGAZINES.filter(m => m.gender === 'woman');

/* ─── static data ─── */
const FILTERS = [
  { label: 'All Issues', value: 'all' },
  { label: 'Business', value: 'business' },
  { label: 'Leadership', value: 'leadership' },
  { label: 'Healthcare', value: 'healthcare' },
  { label: 'Education', value: 'education' },
];

/* Region filter — same icon set as the main Magazine page, reused here so
   the two pages stay visually consistent. */
const REGIONS = [
  {
    label: 'All Regions',
    value: 'all',
    icon: (
      <svg viewBox="0 0 16 16" width="25" height="25" fill="currentColor">
        <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855A8 8 0 0 0 5.145 4H7.5zM4.09 4a9.3 9.3 0 0 1 .64-1.539 7 7 0 0 1 .597-.933A7.03 7.03 0 0 0 2.255 4zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a7 7 0 0 0-.656 2.5zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5zM8.5 5v2.5h2.99a12.5 12.5 0 0 0-.337-2.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5zM5.145 12q.208.58.468 1.068c.552 1.035 1.218 1.65 1.887 1.855V12zm.182 2.472a7 7 0 0 1-.597-.933A9.3 9.3 0 0 1 4.09 12H2.255a7 7 0 0 0 3.072 2.472M3.82 11a13.7 13.7 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5zm6.853 3.472A7 7 0 0 0 13.745 12H11.91a9.3 9.3 0 0 1-.64 1.539 7 7 0 0 1-.597.933M8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855q.26-.487.468-1.068zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.7 13.7 0 0 1-.312 2.5m2.802-3.5a7 7 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7 7 0 0 0-3.072-2.472c.218.284.418.598.597.933M10.855 4a8 8 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4z" />
      </svg>
    ),
  },
  {
    label: 'America',
    value: 'america',
    icon: (
      <svg viewBox="0 0 16 16" width="25" height="25" fill="currentColor">
        <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0M2.04 4.326c.325 1.329 2.532 2.54 3.717 3.19.48.263.793.434.743.484q-.121.12-.242.234c-.416.396-.787.749-.758 1.266.035.634.618.824 1.214 1.017.577.188 1.168.38 1.286.983.082.417-.075.988-.22 1.52-.215.782-.406 1.48.22 1.48 1.5-.5 3.798-3.186 4-5 .138-1.243-2-2-3.5-2.5-.478-.16-.755.081-.99.284-.172.15-.322.279-.51.216-.445-.148-2.5-2-1.5-2.5.78-.39.952-.171 1.227.182.078.099.163.208.273.318.609.304.662-.132.723-.633.039-.322.081-.671.277-.867.434-.434 1.265-.791 2.028-1.12.712-.306 1.365-.587 1.579-.88A7 7 0 1 1 2.04 4.327Z" />
      </svg>
    ),
  },
  {
    label: 'Africa',
    value: 'africa',
    icon: (
      <svg viewBox="0 0 16 16" width="25" height="25" fill="currentColor">
        <path fillRule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 1a6.97 6.97 0 0 0-4.335 1.505l-.285.641a.847.847 0 0 0 1.48.816l.244-.368a.81.81 0 0 1 1.035-.275.81.81 0 0 0 .722 0l.262-.13a1 1 0 0 1 .775-.05l.984.34q.118.04.243.054c.784.093.855.377.694.801a.84.84 0 0 1-1.035.487l-.01-.003C8.273 4.663 7.747 4.5 6 4.5 4.8 4.5 3.5 5.62 3.5 7c0 3 1.935 1.89 3 3 1.146 1.194-1 4 2 4 1.75 0 3-3.5 3-4.5 0-.704 1.5-1 1-2.5-.097-.291-.396-.568-.642-.756-.173-.133-.206-.396-.051-.55a.334.334 0 0 1 .42-.043l1.085.724a.276.276 0 0 0 .348-.035c.15-.15.414-.083.488.117.16.428.445 1.046.847 1.354A7 7 0 0 0 8 1" />
      </svg>
    ),
  },
  {
    label: 'Europe',
    value: 'europe',
    icon: (
      <svg viewBox="0 0 16 16" width="25" height="25" fill="currentColor">
        <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0M3.668 2.501l-.288.646a.847.847 0 0 0 1.479.815l.245-.368a.81.81 0 0 1 1.034-.275.81.81 0 0 0 .724 0l.261-.13a1 1 0 0 1 .775-.05l.984.34q.118.04.243.054c.784.093.855.377.694.801-.155.41-.616.617-1.035.487l-.01-.003C8.274 4.663 7.748 4.5 6 4.5 4.8 4.5 3.5 5.62 3.5 7c0 1.96.826 2.166 1.696 2.382.46.115.935.233 1.304.618.449.467.393 1.181.339 1.877C6.755 12.96 6.674 14 8.5 14c1.75 0 3-3.5 3-4.5 0-.262.208-.468.444-.7.396-.392.87-.86.556-1.8-.097-.291-.396-.568-.641-.756-.174-.133-.207-.396-.052-.551a.33.33 0 0 1 .42-.042l1.085.724c.11.072.255.058.348-.035.15-.15.415-.083.489.117.16.43.445 1.05.849 1.357L15 8A7 7 0 1 1 3.668 2.501" />
      </svg>
    ),
  },
  {
    label: 'Asia',
    value: 'asia',
    icon: (
      <svg viewBox="0 0 16 16" width="25" height="25" fill="currentColor">
        <path d="m10.495 6.92 1.278-.619a.483.483 0 0 0 .126-.782c-.252-.244-.682-.139-.932.107-.23.226-.513.373-.816.53l-.102.054c-.338.178-.264.626.1.736a.48.48 0 0 0 .346-.027ZM7.741 9.808V9.78a.413.413 0 1 1 .783.183l-.22.443a.6.6 0 0 1-.12.167l-.193.185a.36.36 0 1 1-.5-.516l.112-.108a.45.45 0 0 0 .138-.326M5.672 12.5l.482.233A.386.386 0 1 0 6.32 12h-.416a.7.7 0 0 1-.419-.139l-.277-.206a.302.302 0 1 0-.298.52z" />
        <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0M1.612 10.867l.756-1.288a1 1 0 0 1 1.545-.225l1.074 1.005a.986.986 0 0 0 1.36-.011l.038-.037a.88.88 0 0 0 .26-.755c-.075-.548.37-1.033.92-1.099.728-.086 1.587-.324 1.728-.957.086-.386-.114-.83-.361-1.2-.207-.312 0-.8.374-.8.123 0 .24-.055.318-.15l.393-.474c.196-.237.491-.368.797-.403.554-.064 1.407-.277 1.583-.973.098-.391-.192-.634-.484-.88-.254-.212-.51-.426-.515-.741a7 7 0 0 1 3.425 7.692 1 1 0 0 0-.087-.063l-.316-.204a1 1 0 0 0-.977-.06l-.169.082a1 1 0 0 1-.741.051l-1.021-.329A1 1 0 0 0 11.205 9h-.165a1 1 0 0 0-.945.674l-.172.499a1 1 0 0 1-.404.514l-.802.518a1 1 0 0 0-.458.84v.455a1 1 0 0 0 1 1h.257a1 1 0 0 1 .542.16l.762.49a1 1 0 0 0 .283.126 7 7 0 0 1-9.49-3.409Z" />
      </svg>
    ),
  },
];

const FIND_ITEMS = [
  {
    icon: (
      <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4z" />
        <path d="M4 20a8 8 0 0 1 16 0" />
      </svg>
    ),
    title: "Women Leadership Stories",
    desc: "Profiles of women founders, CEOs, and trailblazers making meaningful impact across industries worldwide."
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M4 20V10" />
        <path d="M10 20V4" />
        <path d="M16 20v-8" />
        <path d="M22 20v-14" />
      </svg>
    ),
    title: "Industry Insights",
    desc: "Analytical pieces exploring emerging trends, market shifts, and innovation led by women across global industries."
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" width="32" height="32" fill="currentColor">
        <path d="M12 2l2.9 6 6.6.6-5 4.4 1.5 6.5L12 16.8 6 19.5l1.5-6.5-5-4.4 6.6-.6L12 2z" />
      </svg>
    ),
    title: "Women in Business Spotlight",
    desc: "Narratives of purpose-driven women leaders who are shaping the future of business and society."
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M4 5h7a3 3 0 0 1 3 3v11a3 3 0 0 0-3-3H4z" />
        <path d="M20 5h-7a3 3 0 0 0-3 3v11a3 3 0 0 1 3-3h7z" />
      </svg>
    ),
    title: "Exclusive Longreads",
    desc: "In-depth, research-backed features created with editorial rigor, celebrating the women driving change."
  }
];

/* ─── Magazine Card ─── */
function MCard({ item, onOpenLightbox }) {
  return (
    <article className="mcard fade-in">
      <div
        className="mcard-img-wrap"
        onClick={() => onOpenLightbox(item)}
        role="button"
        tabIndex={0}
        onKeyDown={e => e.key === 'Enter' && onOpenLightbox(item)}
        style={{ cursor: 'pointer' }}
      >
        <img src={getUploadUrl(item.imageUrl)} alt={item.title} loading="lazy" />
        <div className="mcard-overlay" />
        <span className="mcard-badge">{item.year}</span>
        <div className="mcard-hover-cta">Read Issue <span>&#8594;</span></div>
      </div>
      <div className="mcard-body">
        <span className="mcard-cat">{item.category}</span>
        <h3><a href="#">{item.title}</a></h3>
      </div>
    </article>
  );
}

/* ─── Main Page ─── */
export default function WomenPage() {
  const navigate = useNavigate();
  const [magazines, setMagazines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState('all');
  const [activeRegion, setActiveRegion] = useState('all');
  const heroRef = useFadeIn(false);
  const gridRef = useFadeIn(true);
  const findRef = useFadeIn(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    getMagazines()
      .then(r => {
        const data = r.data.data?.length ? r.data.data : FALLBACK_MAGS;
        // Always restrict to women, even when the data comes from the API.
        setMagazines(data.filter(m => m.gender === 'woman'));
      })
      .catch(() => setMagazines(FALLBACK_MAGS))
      .finally(() => setLoading(false));
  }, []);

  const filtered = magazines
    .filter(m => activeFilter === 'all' || m.category === activeFilter)
    .filter(m => activeRegion === 'all' || !m.region || m.region === activeRegion);

  const handleFilter = useCallback((val) => {
    setActiveFilter(val);
    const el = document.getElementById('latest-grid');
    if (el) {
      const offset = el.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: offset, behavior: 'smooth' });
    }
  }, []);

  const handleRegion = useCallback((val) => {
    setActiveRegion(val);
    const el = document.getElementById('latest-grid');
    if (el) {
      const offset = el.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: offset, behavior: 'smooth' });
    }
  }, []);

  return (
    <>
      {/* ── Hero / breadcrumb ── */}
      <section className="mag-hero" ref={heroRef}>
        <div className="mag-hero-bg" />
        <div className="mag-hero-glow" />
        <div className="wrap mag-hero-inner">
          <nav className="breadcrumb" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span className="bc-sep">&#8250;</span>
            <span className="bc-current">Women Leaders</span>
          </nav>
          <h1 className="mag-hero-title">Women <em>Leaders</em></h1>
          <p className="mag-hero-sub">
            Celebrating the founders, executives, and changemakers redefining what leadership
            looks like — exclusive issues spotlighting women shaping business and society.
          </p>

          {/* <div className="filter-bar">
            {FILTERS.map(f => (
              <button
                key={f.value}
                className={`filter-btn${activeFilter === f.value ? ' active' : ''}`}
                onClick={() => handleFilter(f.value)}
              >
                {f.label}
              </button>
            ))}
          </div> */}

          <div className="region-bar" role="group" aria-label="Filter by region">
            {REGIONS.map((r, i) => (
              <button
                key={r.value}
                className={`region-btn${activeRegion === r.value ? ' active' : ''}`}
                onClick={() => handleRegion(r.value)}
                style={{ '--i': i }}
              >
                <span className="region-icon">{r.icon}</span>
                <span className="region-label">{r.label}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* ── Latest Issues Grid ── */}
      <section className="sec" id="latest-grid" ref={gridRef}>
        <div className="wrap">
          <div className="mag-grid-head">
            <h2 className="mag-grid-title">Latest Edition</h2>
            {/* <p className="mag-count">
              <span>{filtered.length}</span> issue{filtered.length !== 1 ? 's' : ''}
            </p> */}
          </div>

          {loading ? (
            <div className="mag-grid">
              {Array.from({ length: 10 }).map((_, i) => (
                <div key={i} className="mcard">
                  <div style={{ aspectRatio: '3/4', background: 'var(--card2)' }} />
                  <div className="mcard-body">
                    <div className="news-skeleton" style={{ height: 10, marginBottom: 8, borderRadius: 3 }} />
                    <div className="news-skeleton" style={{ height: 10, width: '65%', borderRadius: 3 }} />
                  </div>
                </div>
              ))}
            </div>
          ) : filtered.length === 0 ? (
            <div className="no-results">
              <svg width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="rgba(201,168,76,0.5)" strokeWidth="1.5">
                <circle cx="11" cy="11" r="8" /><path strokeLinecap="round" d="M21 21l-4.35-4.35" />
              </svg>
              <p>No issues found for this category.</p>
            </div>
          ) : (
            <div className="mag-grid">
              {filtered.map(m => (
                <MCard
                  key={m._id}
                  item={m}
                  onOpenLightbox={() => navigate(`/magazine/${m._id}`)}
                />
              ))}
            </div>
          )}
        </div>
      </section>

      {/* ── What You'll Find ── */}
      <section className="find-sec" ref={findRef}>
        <div className="find-bg" />
        <div className="wrap">
          <h2 className="find-title">
            What You'll Find Inside <em>Women Leaders</em>
          </h2>
          <div className="find-grid">
            {FIND_ITEMS.map((item, i) => (
              <div key={i} className="find-card fade-in">
                <div className="find-icon">
                  <span style={{ fontSize: '1.6rem' }}>{item.icon}</span>
                </div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
